import React, { useEffect } from "react";
import NavbarPortal from "../../Components/Navbar";
import TentangKami from "../../Components/Tentang/tentang";
import FooterPortal from "../../Components/Footer";

export default function TentangKamiPage() {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    <div className="font-signika">
      <NavbarPortal />
      <div className="-mt-10 max-sm:-mt-20">
        <TentangKami />
      </div>

      <FooterPortal />
    </div>
  );
}
